import React, { useEffect, useRef, useState, useContext } from 'react'
import Input from '../../controls/Input'
import ListSubheader from '@mui/material/ListSubheader'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import toast from 'react-hot-toast'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { Button, Modal, Fade, Box, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Editor from "@monaco-editor/react";
import { completionItemProvider } from './completionItemProvider'
import { completionDisplayItemProvider } from './completionDisplayItemProvider'
import { AGGREFATE_FUNCTIONS, functionEval, universalRegex, calculatedFieldRegex } from '../../../helper/calculatedFunctions'
import { getMeasuresList,getMeasuresLists, addMeasures, updateMeasure, } from '../../../config/services/measures'
import { getDataSetDetails } from '../../../config/services/datasets'
import { addVersion } from '../../../config/services/config'
import Loader from '../../../pages/Loader'
import { ReactComponent as IconAngleDown } from "../../../assets/icons/icon-angle-down.svg"
import { ReactComponent as IconAngleUp } from "../../../assets/icons/icon-angle-up.svg"
// import { MeasureListContext } from "../../../contexts/MeasureListContext";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginBottom: '20px',
        width: '100%',
        fontSize: '20px',
        letterSpacing: '1px',
    },
    textArea: {
        width: '100%',
        fontSize: '20px',
        letterSpacing: '1px',
    },
    saveBtn: {
        fontSize: '12px',
        margin: theme.spacing(1),
    },
}))

const calculatedFieldPopUp = {
    status: true,
    popupStyle: {
        dialog: {
            width: '100%',
            maxWidth: '1000px',
            minHeight: '51vh',
        },
        content: {
            overflowY: 'auto',
        },
    },
}

const legend = {
    tokenTypes: [
        'function', 'params', 'field', 'operator'
    ],
    tokenModifiers: [
        'declaration', 'documentation', 'readonly', 'static', 'abstract', 'deprecated',
        'modification', 'async'
    ]
};

const getModifier = (modifiers) => {
    if (typeof modifiers === 'string') {
        modifiers = [modifiers];
    }
    if (Array.isArray(modifiers)) {
        let nModifiers = 0;
        for (let modifier of modifiers) {
            const nModifier = legend.tokenModifiers.indexOf(modifier);
            if (nModifier > -1) {
                nModifiers |= (1 << nModifier) >>> 0;
            }
        }
        return nModifiers;
    } else {
        return 0;
    }
}
const tokenPattern = new RegExp('([a-zA-Z]+)((?:\\.[a-zA-Z]+)*)', 'g');


function CalculatedFields(props) {
    const classes = useStyles()
    const [openMeasures, setopenMeasures] = React.useState(false)
    const [openFuntions, setopenFunctions] = React.useState(true)
    const [measures, setMeasures] = React.useState([])
    const [selectedDataSetDetails, setSelectedDataSetDetails] = useState({})
    let [fieldName, setFieldName] = useState('')
    const [fieldDescription, setFieldDescription] = useState('')
    const [calculatedField, setCalculatedField] = useState('')
    const [calculatedDisplayField, setCalculatedDisplayField] = useState('')
    const [showDefinationDiv, setShowDefinationDiv] = useState(false)
    const [selectedFunction, setSelectedFunction] = useState({})
    const [loader, setLoading] = useState(false)
    const [measureId, setMeasureId] = useState('')
    //const [editorValue, setEditorValue] = useState('')
    const [editorObj, setEditorObj] = useState({})
    const [monacoObj, setMonacoObj] = useState({})
    // const MeasureListContextObj = useContext(MeasureListContext);

    const handleClickMeasures = () => {
        setopenMeasures(!openMeasures)
    }

    const getEditFieldsProps = () => {
        if (props.isEdit) {
            setFieldName(props?.calculatedDisplayName?.trim() || props?.fieldName?.trim())
            setCalculatedField(props?.fieldValue)
            setCalculatedDisplayField(props?.displayCalculatedField || props?.fieldValue)
            setFieldDescription(props?.calculatedDescription)
            setMeasureId(props.measureId)
        }
    }
    useEffect(() => { getEditFieldsProps() }, [])

    function getCalcDisplayArrayOld(str) {
        const funcMatch = str.match(/^(\w+)\s*\(([\s\S]*)\)$/);
        if (!funcMatch) return [];
      
        const [, functionName, argsStr] = funcMatch;
        const args = [];
      
        let current = '';
        let depth = 0;
      
        for (let i = 0; i < argsStr.length; i++) {
          const char = argsStr[i];
          if (char === '(') depth++;
          if (char === ')') depth--;
          if (char === ',' && depth === 0) {
            args.push(current.trim());
            current = '';
          } else {
            current += char;
          }
        }
        if (current.trim()) args.push(current.trim());
      
        // Token extraction regex:
        const tokenRegex = /[\w\s]+--\w+|[\w\s]+|\d+(?:\.\d+)?/g;
      
        const result = [functionName];
      
        args.forEach(arg => {
          const tokens = arg.match(tokenRegex) || [];
          result.push(...tokens.map(t => t.trim()).filter(Boolean));
        });
      
        return result;
    }
      
    function getCalcDisplayArray_v1(expression) {
        // Helper to split function arguments correctly
        function splitFunctionArgs(argsStr) {
          const args = [];
          let current = '';
          let depth = 0;
      
          for (let i = 0; i < argsStr.length; i++) {
            const char = argsStr[i];
            if (char === '(') depth++;
            if (char === ')') depth--;
            if (char === ',' && depth === 0) {
              args.push(current.trim());
              current = '';
            } else {
              current += char;
            }
          }
          if (current.trim()) args.push(current.trim());
          return args;
        }
      
        // Main token regex
        const tokenRegex = /[\w\s]+--\w+|[\w\s]+|>=|<=|!=|=|>|<|AND|OR|[+\-*/()]|\d+(?:\.\d+)?|'.*?'/gi;
      
        const matchFunc = expression.match(/^(\w+)\s*\(([\s\S]*)\)$/);
        let tokens = [];
      
        if (matchFunc) {
          const [, funcName, argsStr] = matchFunc;
          tokens.push(funcName);
          const args = splitFunctionArgs(argsStr);
          args.forEach(arg => {
            const innerTokens = (arg.match(tokenRegex) || []).map(t =>
              t.startsWith("'") && t.endsWith("'") ? t.slice(1, -1) : t
            );
            tokens.push(...innerTokens);
          });
        } else {
          // Not a function, just a plain expression
          tokens = (expression.match(tokenRegex) || []).map(t =>
            t.startsWith("'") && t.endsWith("'") ? t.slice(1, -1) : t
          );
        }
      
        return tokens.map(t => t.trim()).filter(Boolean);
    }

    function getCalcDisplayArray(expression) {
  const regex = /'[^']*'|[A-Za-z0-9\s]+--[A-Za-z0-9]+|\b(?:AND|OR|IS NULL|IS NOT NULL)\b|[><!]=|[=><*/(),-]|\b\w+(?: \w+)*\b/g;
  const rawTokens = expression.match(regex) || [];

  const cleaned = [];

  for (let i = 0; i < rawTokens.length; i++) {
    let token = rawTokens[i].trim();

    // Combine multi-word field names
    if (token.match(/^[A-Za-z]+(?: [A-Za-z]+)+$/)) {
      // If next token is also a word, merge until punctuation/operator
      while (i + 1 < rawTokens.length && /^[A-Za-z]+$/.test(rawTokens[i + 1])) {
        token += ' ' + rawTokens[++i];
      }
    }

    cleaned.push(token);
  }

  return cleaned.filter(Boolean);
}
     
            
    const handleSetHiddenCalcField = () => {        
        let calcFeild = calculatedDisplayField.trim();

        if (calculatedDisplayField && measures && measures.length) {
            let mappedFeild = {}
            let regex = new RegExp(/\b\w+(?=\s*\()|[\w\s]+--\w+|[\w\s]+|\d+/g);
            let valArr = getCalcDisplayArray(calculatedDisplayField, regex)
            valArr = valArr.filter(obj => obj && obj.trim()).map(obj => obj.trim())
            console.log(valArr)
            //console.log('clicked',calcFeild)
            if (valArr && valArr.length) {
                for (let val of valArr) {
                    const exist = measures.find(meas => (meas?.displayName?.trim() == val || meas?.name == val));
                    //console.log(val,exist)
                    if (exist) {
                        mappedFeild[val] = exist.name
                    }
                }
            }

            if (Object.keys(mappedFeild).length) {
                Object.keys(mappedFeild).forEach(field => {
                    calcFeild = calcFeild.replaceAll(field, mappedFeild[field])
                })
            }
            console.log(calcFeild,mappedFeild)
            setCalculatedField(calcFeild)
            saveCalculatedField(calcFeild)
        }
    }


    const saveCalculatedField = async (calcFeild) => {
        let displayName = '';
        let newFieldName = '';

        fieldName = fieldName?.trim()

        if (!fieldName) {
            toast.error('Field Name is required')
            return false
        }
        if (validateFieldName(fieldName)) {
            toast.error('Field name can only contain alphabets')
            return false;
        }

        /* if (/\s/.test(fieldName)) {
            displayName = fieldName;
            newFieldName = fieldName.replace(' ', '');
        }
        else {
            displayName = fieldName;
        } */

        if (calcFeild) {
            let editFlag = props.isEdit ? measureId : false
            const dimensions = await getFunctionsMetaData(calcFeild.trim(), fieldName, editFlag)
            if (dimensions) {
                //dimensions.name = newFieldName ? newFieldName : fieldName
                dimensions.calculatedField = calcFeild.trim()
                dimensions.displayCalculatedField = calculatedDisplayField.trim()
                dimensions.dataSetId = props.selectedDataset
                dimensions.displayName = fieldName
                dimensions.description = fieldDescription  
                //console.log(dimensions)              
                //return
                if (!props.isEdit) {
                    setLoading(true)
                    dimensions.isHidden = false
                    dimensions.joinHiddenField = false
                    try {
                        const res = await addMeasures(dimensions)
                        await addVersion({ version: new Date().getTime().toString() })
                        toast.success(res.message)

                        // if (MeasureListContextObj?.dispatch)
                        //     MeasureListContextObj.dispatch({ type: 'UPDATE_MEASURE_LIST' });

                        handleCancel();
                    } catch (err) {
                        toast.error(err)
                    } finally {
                        setLoading(false)
                    }
                } else {
                    setLoading(true)
                    try {
                        dimensions.measureId = measureId
                        const res = await updateMeasure(dimensions)
                        await addVersion({ version: new Date().getTime().toString() })
                        toast.success(res.message)

                        // if (MeasureListContextObj?.dispatch)
                        //     MeasureListContextObj.dispatch({ type: 'UPDATE_MEASURE_LIST' });

                        handleCancel()
                    } catch (err) {
                        toast.error(err)
                    } finally {
                        setLoading(false)
                    }
                }
            }
        } else {
            toast.error('Calculated Field is required')
        }
    }

    const getFunctionsMetaData = async (calculatedField, displayName, editFlag) => {
        let dimension = await functionEval(calculatedField, displayName, selectedDataSetDetails, measures, editFlag)
        if (dimension) {
            return dimension
        }
    }

    const validateFieldName = (str) => {
        if (/[^a-zA-Z ]/g.test(str)) {
            return true;
        }
        return false
    }

    const showFunctionDefination = (element) => {
        setShowDefinationDiv(true)
        setSelectedFunction(element)
    }

    const handleClickFuntions = () => {
        setopenFunctions(!openFuntions)
    }

    const getSelectedDataSet = async () => {
        setLoading(true)
        let reportDetails = props?.reportDetails
        let params = { dataSetId: props.selectedDataset }
        const datasetRes = await getDataSetDetails(params)
        let dataset = datasetRes.result
        let joinedDatasets = []      
        if(reportDetails?.joinFlag && dataset?.customJoin && dataset?.customJoin.constructor === Array){
            joinedDatasets = dataset?.customJoin.map(obj => obj.dataSetId)
        }    
        let mesParams = { dataSetId: [props.selectedDataset,...joinedDatasets], search: '', sortKey: 'displayName', sortOrder: 1 }
        const mesResult = await getMeasuresLists(mesParams)
        let list = mesResult.result
        list = list.map(measure => {            
            measure.displayName = measure?.dataset ? (measure.dataset._id != props.selectedDataset ? ( `${(measure?.displayName ?? measure?.name)}--${measure.dataset.dataSetName}`): ( measure?.displayName ?? measure?.name)) : ( measure?.displayName ?? measure?.name)
            measure.name = `${measure.dataset.dataSetName}.${measure.name}`;
            return measure
        })
        setMeasures(list)
        setSelectedDataSetDetails(dataset)
        //console.log(dataset,list)
        setLoading(false)
    }

    const handleEditorChange = (value, event) => {
        setCalculatedField(value)
    }

    const handleDisplayEditorChange = (value) => {
        setCalculatedDisplayField(value)
    }

    const handleEditorDidMount = (editor, monaco) => {
        // setEditorObj is used to store return of registerCompletionItemProvider, to trigger dispose method later on popup close
        setEditorObj(monaco.languages.registerCompletionItemProvider('mySpecialLanguage', completionDisplayItemProvider(monaco, measures, AGGREFATE_FUNCTIONS, props,)))

        monaco.languages.registerDocumentSemanticTokensProvider('mySpecialLanguage', {
            getLegend: function () {
                return legend;
            },
            provideDocumentSemanticTokens: function (model, lastResultId, token) {
                const lines = model.getLinesContent();
                const data = [];
                let prevLine = 0;
                let prevChar = 0;

                let functionNames = AGGREFATE_FUNCTIONS.map(fn => fn.functionName)
                let stringMatches = ['params']
                let fieldMatches = measures.map(measure => measure?.displayName ?? measure?.name)
                let operatorMatches = ['AND', 'and', 'OR', 'or', 'IS NOT NULL', 'IS NULL']

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i];

                    for (let match = null; match = tokenPattern.exec(line);) {
                        let type

                        if (functionNames.find(str => str === match[1])) {
                            type = 0
                        }
                        else if (stringMatches.find(str => str === match[1])) {
                            type = 1
                        }
                        else if (fieldMatches.find(str => str === match[1])) {
                            type = 2
                        }
                        else if (operatorMatches.find(str => str === match[1])) {
                            type = 3
                        }

                        if (type === -1) {
                            continue;
                        }

                        let modifier = match[2].length ? getModifier(match[2].split('.').slice(1)) : 0;

                        data.push(
                            i - prevLine,
                            prevLine === i ? match.index - prevChar : match.index,
                            match[0].length,
                            type,
                            modifier,
                        );
                        prevLine = i;
                        prevChar = match.index;
                    }
                }

                return {
                    data: new Uint32Array(data),
                    resultId: null
                };
            },
            releaseDocumentSemanticTokens: function (resultId) { }
        })
    }

    const handleHiddenEditorDidMount = (editor, monaco) => {
        // setEditorObj is used to store return of registerCompletionItemProvider, to trigger dispose method later on popup close
        setEditorObj(monaco.languages.registerCompletionItemProvider('mySpecialLanguage2', completionItemProvider(monaco, measures, AGGREFATE_FUNCTIONS, props)))

        monaco.languages.registerDocumentSemanticTokensProvider('mySpecialLanguage2', {
            getLegend: function () {
                return legend;
            },
            provideDocumentSemanticTokens: function (model, lastResultId, token) {
                const lines = model.getLinesContent();
                const data = [];
                let prevLine = 0;
                let prevChar = 0;

                let functionNames = AGGREFATE_FUNCTIONS.map(fn => fn.functionName)
                let stringMatches = ['params']
                let fieldMatches = measures.map(msr => msr.name)
                let operatorMatches = ['AND', 'and', 'OR', 'or', 'IS NOT NULL', 'IS NULL']

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i];

                    for (let match = null; match = tokenPattern.exec(line);) {
                        let type

                        if (functionNames.find(str => str === match[1])) {
                            type = 0
                        }
                        else if (stringMatches.find(str => str === match[1])) {
                            type = 1
                        }
                        else if (fieldMatches.find(str => str === match[1])) {
                            type = 2
                        }
                        else if (operatorMatches.find(str => str === match[1])) {
                            type = 3
                        }

                        if (type === -1) {
                            continue;
                        }

                        let modifier = match[2].length ? getModifier(match[2].split('.').slice(1)) : 0;

                        data.push(
                            i - prevLine,
                            prevLine === i ? match.index - prevChar : match.index,
                            match[0].length,
                            type,
                            modifier,
                        );
                        prevLine = i;
                        prevChar = match.index;
                    }
                }

                return {
                    data: new Uint32Array(data),
                    resultId: null
                };
            },
            releaseDocumentSemanticTokens: function (resultId) { }
        })
    }

    const handleEditorWillMount = (monaco) => {
        const theme = {
            base: 'vs',
            inherit: true,
            rules: [
                { token: 'function', foreground: '070dff', fontStyle: 'bold italic' },
                { token: 'params', foreground: 'e25858', fontStyle: 'italic' },
                { token: 'field', foreground: '0f7152', fontStyle: 'italic' },
                { token: 'operator', foreground: 'ee4444', fontStyle: 'bold' },
                { token: 'custom-info', foreground: 'a3a7a9', background: 'ffffff' },
                { token: 'custom-error', foreground: 'ee4444' },
                { token: 'custom-notice', foreground: '1055af' },
                { token: 'custom-date', foreground: '20aa20' },
            ],
            colors: {
                'editor.foreground': '#000000',
                'editor.background': '#f7f7f7',
                'editorCursor.foreground': '#8B0000',
                'editor.lineHighlightBackground': '#0000FF20',
                'editorLineNumber.foreground': '#008800',
                'editor.selectionBackground': '#88000030',
                'editor.inactiveSelectionBackground': '#88000015'
            }
        }
        monaco.editor.defineTheme('myTheme', theme)
        monaco.languages.registerCompletionItemProvider().dispose()
        monaco.languages.register({ id: 'mySpecialLanguage' });
        setEditorObj(monaco)
    }

    const handleHiddenEditorWillMount = (monaco) => {
        const theme = {
            base: 'vs',
            inherit: true,
            rules: [
                { token: 'function', foreground: '070dff', fontStyle: 'bold italic' },
                { token: 'params', foreground: 'e25858', fontStyle: 'italic' },
                { token: 'field', foreground: '0f7152', fontStyle: 'italic' },
                { token: 'operator', foreground: 'ee4444', fontStyle: 'bold' },
                { token: 'custom-info', foreground: 'a3a7a9', background: 'ffffff' },
                { token: 'custom-error', foreground: 'ee4444' },
                { token: 'custom-notice', foreground: '1055af' },
                { token: 'custom-date', foreground: '20aa20' },
            ],
            colors: {
                'editor.foreground': '#000000',
                'editor.background': '#f7f7f7',
                'editorCursor.foreground': '#8B0000',
                'editor.lineHighlightBackground': '#0000FF20',
                'editorLineNumber.foreground': '#008800',
                'editor.selectionBackground': '#88000030',
                'editor.inactiveSelectionBackground': '#88000015'  
            }
        }
        monaco.editor.defineTheme('myTheme', theme)
        monaco.languages.registerCompletionItemProvider("shell").dispose()
        monaco.languages.register({ id: 'mySpecialLanguage2' });
        setMonacoObj(monaco);
    }

    const handleEditorValidation = (markers) => {
        markers.forEach(marker => console.log('onValidate:', marker.message));
    }

    const handleCancel = () => {
        editorObj.dispose() // this is used to dispose registerCompletionItemProvider, to prevent duplicate suggestions
        props.closeCalcltdFldDialog();
    }

    let { isEdit, openPopup, setOpenPopup } = props

    useEffect(() => {
        getSelectedDataSet()
        
        return () => {
            if(editorObj && editorObj.dispose){
                editorObj.dispose()
            }            
            //monacoObj.dispose()
        }
    },[])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-paper"
            open={openPopup}
            onClose={handleCancel}
            closeAfterTransition
            //calculatedFieldPopUp={calculatedFieldPopUp}
            //setOpenPopup={handleCancel}
        >
            <Fade in={openPopup}>
                <Box className="model-paper modal-box modal-lg" id="transition-modal-title">
                    <Box className="modal-header pl-0 p-2" >
                        <Typography variant="subtitle1" className="modal-header-title" id="simple-modal-title">{`${isEdit ? 'Update' : 'Add'} Calculated Field`}</Typography>
                    </Box>
                    <Box className="modal-content">
                        {loader && <Loader />}
                        <Grid container spacing={0} >
                            <Grid item xs={12} md={8} >
                                <Paper>
                                    <form noValidate autoComplete="on">
                                        <Typography variant="subtitle1" className="form_input_label text-left">Field Name</Typography>
                                        <Input
                                            id="standard-basic"
                                            //label="Field Name"
                                            size="small"
                                            className={classes.textField + " report_form_ui_input"}
                                            value={fieldName}
                                            onChange={(e) => setFieldName(e.target.value)}
                                        />
                                        <Typography variant="subtitle1" className="form_input_label text-left">Description</Typography>
                                        <Input
                                            label=""
                                            size="small"
                                            className={classes.textField + " report_form_ui_input"}
                                            value={fieldDescription}
                                            onChange={(e) => setFieldDescription(e.target.value)}
                                        />

                                        {measures?.length && AGGREFATE_FUNCTIONS?.length ?
                                            <>
                                                <Paper>
                                                    <Editor
                                                        height="30vh"
                                                        defaultLanguage="mySpecialLanguage"
                                                        theme="myTheme"
                                                        value={calculatedDisplayField}
                                                        onChange={handleDisplayEditorChange}
                                                        onMount={handleEditorDidMount}
                                                        beforeMount={handleEditorWillMount}
                                                        onValidate={handleEditorValidation}
                                                        options={{
                                                            "semanticHighlighting.enabled": true,
                                                            minimap: { enabled: false }, wordWrap: 'on', renderLineHighlight: "none", scrollbar: { arrowSize: 1 }
                                                        }}
                                                    />

                                                </Paper>

                                                {/* <Paper className="hiddenEditor">
                                                    <Editor
                                                        height="30vh"
                                                        defaultLanguage="mySpecialLanguage2"
                                                        theme="myTheme"
                                                        value={calculatedField}
                                                        onChange={handleEditorChange}
                                                        onMount={handleHiddenEditorDidMount}
                                                        beforeMount={handleHiddenEditorWillMount}
                                                        onValidate={handleEditorValidation}
                                                        options={{
                                                            "semanticHighlighting.enabled": true,
                                                            minimap: { enabled: false }, wordWrap: 'on', renderLineHighlight: "none", scrollbar: { arrowSize: 1 }
                                                        }}
                                                    />

                                                </Paper> */}

                                            </> : null}
                                    </form>

                                    {showDefinationDiv && (
                                        <div style={{ marginTop: '0px' }}>
                                            <h3>{selectedFunction.name}</h3>
                                            <div>{selectedFunction.description}</div>
                                            <h4>SYNTAX</h4>
                                            <code>{selectedFunction.syntax}</code>
                                        </div>
                                    )}
                                </Paper>
                            </Grid>

                            <Grid xs={12} md={4} item sm container className="filters_calculated_fields">
                                <Grid container item xs flexDirection="column" className="filters_calculated_fields_container">
                                    <Grid item xs sx={{ mb: 1 }} order={{ lg: 1, md: 1, sm: 2, xs: 2 }}>
                                        <Button variant="contained" size="small" onClick={handleCancel} color="error" className={classes.saveBtn + " report_form_ui_btn cancel mr-1"}> Cancel </Button>
                                        <Button variant="contained" size="small" onClick={handleSetHiddenCalcField} color="primary" className={classes.saveBtn + " report_form_ui_btn submit"}> Save </Button>
                                    </Grid>
                                    <Grid container item order={{ lg: 2, md: 2, sm: 1, xs: 1 }} flexDirection="column" sx={{ mb: 1 }}>
                                        <Grid item xs >
                                            <List sx={{ p: 0 }}
                                                subheader={
                                                    <ListSubheader sx={{ p: 0 }} component="div">
                                                        <ListItem className='list-item' button onClick={handleClickMeasures}>
                                                            <ListItemText primary="Fields (All)" /> {openMeasures ? <IconAngleUp /> : <IconAngleDown />}
                                                        </ListItem>
                                                    </ListSubheader>
                                                }
                                                className="cm_field_list"
                                            >
                                                <Collapse in={openMeasures} timeout="auto" unmountOnExit sx={{ p: 0 }}>
                                                    <List
                                                        component="div"
                                                        disablePadding
                                                        sx={{
                                                            padding: '0 !important',
                                                            overflowY: 'scroll',
                                                            maxHeight: '25vh',
                                                        }}
                                                    >
                                                        {measures?.map((measure) => (
                                                            <ListItem className='list-item' button key={measure._id}> 
                                                                <ListItemText 
                                                                    primary={measure?.dataset ? (measure.dataset._id != selectedDataSetDetails._id ? ( `${(measure?.displayName ?? measure?.name)}-${measure.dataset.dataSetName}`): ( measure?.displayName ?? measure?.name)) : ( measure?.displayName ?? measure?.name)} 
                                                                /> 
                                                            </ListItem>)
                                                        )}
                                                    </List>
                                                </Collapse>
                                            </List>
                                        </Grid>

                                        <Grid item xs>
                                            <List sx={{ p: 0 }}
                                                subheader={
                                                    <ListSubheader sx={{ p: 0 }} component="div" id="nested-list-subheader">
                                                        <ListItem className='list-item' button onClick={handleClickFuntions}>
                                                            <ListItemText primary="Functions (Aggregate)" />
                                                            {openFuntions ? <IconAngleUp /> : <IconAngleDown />}
                                                        </ListItem>
                                                    </ListSubheader>
                                                }
                                            >
                                                <Collapse in={openFuntions} timeout="auto" unmountOnExit>
                                                    <List
                                                        component="div"
                                                        disablePadding
                                                        sx={{
                                                            paddingLeft: '0',
                                                            overflowY: 'scroll',
                                                            maxHeight: '20vh',
                                                        }}
                                                    >
                                                        {AGGREFATE_FUNCTIONS?.map((ele) => {
                                                            return (
                                                                <ListItem className='list-item' button key={Math.random()} onClick={(e) => showFunctionDefination(ele)} v>
                                                                    <ListItemText primary={ele.name.toLowerCase()} />
                                                                </ListItem>
                                                            )
                                                        })}
                                                    </List>
                                                </Collapse>
                                            </List>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    )
}

export default CalculatedFields
